var _defs, _rect, _path, _rect2, _rect3, _rect4, _path2, _rect5, _rect6, _rect7, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccountingAbacus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".accounting-abacus_svg__accounting-abacus_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "accounting-abacus_svg__accounting-abacus_svg__a",
    x: 1.5,
    y: 0.75,
    width: 21,
    height: 22.5,
    rx: 1.5,
    ry: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "accounting-abacus_svg__accounting-abacus_svg__a",
    d: "M7.5.75v3m0 3v6m0 7.5v3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "accounting-abacus_svg__accounting-abacus_svg__a",
    x: 5.25,
    y: 3.75,
    width: 4.5,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "accounting-abacus_svg__accounting-abacus_svg__a",
    x: 5.25,
    y: 12.75,
    width: 4.5,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "accounting-abacus_svg__accounting-abacus_svg__a",
    x: 5.25,
    y: 17.25,
    width: 4.5,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "accounting-abacus_svg__accounting-abacus_svg__a",
    d: "M16.5 23.25v-3m0-3v-6m0-7.5v-3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "accounting-abacus_svg__accounting-abacus_svg__a",
    x: 14.25,
    y: 17.25,
    width: 4.5,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "accounting-abacus_svg__accounting-abacus_svg__a",
    x: 14.25,
    y: 8.25,
    width: 4.5,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "accounting-abacus_svg__accounting-abacus_svg__a",
    x: 14.25,
    y: 3.75,
    width: 4.5,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "accounting-abacus_svg__accounting-abacus_svg__a",
    d: "M16.5 6.75v1.5m-9 7.5v1.5"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MS41cHg7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJhIiB4PSIxLjUiIHk9IjAuNzUiIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMi41IiByeD0iMS41IiByeT0iMS41Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSI3LjUiIHkxPSIwLjc1IiB4Mj0iNy41IiB5Mj0iMy43NSIvPjxsaW5lIGNsYXNzPSJhIiB4MT0iNy41IiB5MT0iNi43NSIgeDI9IjcuNSIgeTI9IjEyLjc1Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSI3LjUiIHkxPSIyMC4yNSIgeDI9IjcuNSIgeTI9IjIzLjI1Ii8+PHJlY3QgY2xhc3M9ImEiIHg9IjUuMjUiIHk9IjMuNzUiIHdpZHRoPSI0LjUiIGhlaWdodD0iMyIgcng9IjEuNSIgcnk9IjEuNSIvPjxyZWN0IGNsYXNzPSJhIiB4PSI1LjI1IiB5PSIxMi43NSIgd2lkdGg9IjQuNSIgaGVpZ2h0PSIzIiByeD0iMS41IiByeT0iMS41Ii8+PHJlY3QgY2xhc3M9ImEiIHg9IjUuMjUiIHk9IjE3LjI1IiB3aWR0aD0iNC41IiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIHJ5PSIxLjUiLz48bGluZSBjbGFzcz0iYSIgeDE9IjE2LjUiIHkxPSIyMy4yNSIgeDI9IjE2LjUiIHkyPSIyMC4yNSIvPjxsaW5lIGNsYXNzPSJhIiB4MT0iMTYuNSIgeTE9IjE3LjI1IiB4Mj0iMTYuNSIgeTI9IjExLjI1Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSIxNi41IiB5MT0iMy43NSIgeDI9IjE2LjUiIHkyPSIwLjc1Ii8+PHJlY3QgY2xhc3M9ImEiIHg9IjE0LjI1IiB5PSIxNy4yNSIgd2lkdGg9IjQuNSIgaGVpZ2h0PSIzIiByeD0iMS41IiByeT0iMS41Ii8+PHJlY3QgY2xhc3M9ImEiIHg9IjE0LjI1IiB5PSI4LjI1IiB3aWR0aD0iNC41IiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIHJ5PSIxLjUiLz48cmVjdCBjbGFzcz0iYSIgeD0iMTQuMjUiIHk9IjMuNzUiIHdpZHRoPSI0LjUiIGhlaWdodD0iMyIgcng9IjEuNSIgcnk9IjEuNSIvPjxsaW5lIGNsYXNzPSJhIiB4MT0iMTYuNSIgeTE9IjYuNzUiIHgyPSIxNi41IiB5Mj0iOC4yNSIvPjxsaW5lIGNsYXNzPSJhIiB4MT0iNy41IiB5MT0iMTUuNzUiIHgyPSI3LjUiIHkyPSIxNy4yNSIvPjwvc3ZnPgo=";
export { SvgAccountingAbacus as ReactComponent };